// IELTS Mock 7 — Academic Writing (table + agree/disagree essay)
// Same shape as IELTS_DATA_WRITING in ../IeltsWriting.js. `mock` is forwarded to
// /api/scoring/writing-validate so it is checked against this mock's reference points.
const IELTS_MOCK7_WRITING = {
  title: "Academic Writing Practice Test 7",
  tasks: [
    {
      id: "task1",
      mock: 7,
      title: "Task 1: Report (20 min)",
      prompt:
        "The table shows the percentage of workers in the town of Ashbury who used different methods of travel to get to work in 1995, 2005, 2015 and 2025. Summarise the information by selecting and reporting the main features, and make comparisons where relevant.",
      image: "/images/ielts-mock7/writing_task1_commuting.svg",
      minWords: 150,
      keywords: ["car", "bus", "train", "bicycle", "cycl", "walk", "home", "percent", "proportion", "1995", "2025", "increas", "declin", "compar"],
      diagramType: "table"
    },
    {
      id: "task2",
      mock: 7,
      title: "Task 2: Essay (40 min)",
      prompt:
        "Some people believe that unpaid community service, such as helping in hospitals or cleaning public spaces, should be a compulsory part of high school education. To what extent do you agree or disagree?",
      minWords: 250,
      keywords: ["community service", "volunteer", "compulsory", "unpaid", "student", "school", "society", "skill", "experience", "agree", "responsib", "opinion"]
    }
  ]
};

export default IELTS_MOCK7_WRITING;
